import { render } from "./ClassroomSetup.vue?vue&type=template&id=2538dd63&scoped=true"
import script from "./ClassroomSetup.vue?vue&type=script&lang=js"
export * from "./ClassroomSetup.vue?vue&type=script&lang=js"

import "./ClassroomSetup.vue?vue&type=style&index=0&id=2538dd63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2538dd63"]])

export default __exports__